import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { precisionRound } from 'shared/utils';
import { format, isValid } from 'date-fns';
// import font from './NanumGothic-normal.js';

const formatDate = (date) => {
  const d = new Date(date);
  return isValid(d) ? format(d, 'yyyy/MM/dd') : '';
};

const StatementPDF = (statementList, sum, companyName, companyId, stDate, edDate) => {
  const doc = new jsPDF();

  // 제목
  doc.setFontSize(16);
  doc.text(`Statement Report - ${companyName} (${companyId})`, 14, 20);

  // 기간 표시
  doc.setFontSize(12);
  doc.text(`Period: ${formatDate(stDate)} ~ ${formatDate(edDate)}`, 14, 30);

  // 테이블 컬럼
  const tableColumn = ["Date", "Bill Id", "Type", "Page", "Size", "Cost", "Tax", "Total", "Paid", "Tax", "Total", "Balance", "Method"];

  // 테이블 데이터
  const tableRows = statementList.map(item => [
    item.sDate,
    item.adId || "",
    // item.adTitle,
    item.adType,
    item.page,
    item.size,
    item.cost != null ? precisionRound(item.cost) : "",
    item.taxAmount != null ? precisionRound(item.taxAmount) : "",
    item.total != null ? precisionRound(item.total) : "",
    item.paidAmount != null ? precisionRound(item.paidAmount) : "",
    item.paidTax != null ? precisionRound(item.paidTax) : "",
    item.paidTotal != null ? precisionRound(item.paidTotal) : "",
    item.balance != null ? precisionRound(item.balance) : "",
    item.method || ""
  ]);

  // 테이블 생성
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 34,
    styles: {
      fontSize: 9,
      cellPadding: 2,
    },
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontStyle: 'bold',
    },
    theme: 'plain', // 세로선 제거
    didParseCell: function (data) {
      // 헤더는 제외
      if (data.section !== 'body') return;

      const rowIndex = data.row.index;
      const rowItem = statementList[rowIndex];

      const hasAdId = !!rowItem?.adId;
      const hasPayId = !!rowItem?.payId;

      // adId 없고, payId 있는 경우 → 회색 배경
      if (!hasAdId && hasPayId) {
        data.cell.styles.fillColor = [240, 240, 240]; // 연한 회색
      }

      // adId 있고 payId 없는 경우 → 기본 (아무 처리 안 함)
    }
  });


  // 파일명에 오늘 날짜 추가
  const todayString = () => {
    const d = new Date();
    return format(d, 'yyyyMMdd'); // 20260109 같은 형식
  };

  // 파일명에 회사 이름과 아이디 추가
  const safeFileName = (text = '') =>
    text
      .replace(/[\\/:*?"<>|]/g, '') // 윈도우 금지 문자 제거
      .replace(/\s+/g, '_');

  const addCompanyFooter = (doc) => {
    const pageCount = doc.getNumberOfPages();
    doc.setPage(pageCount); // 마지막 페이지

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const rightMargin = 14;
    const bottomMargin = 30;

    let y = pageHeight - bottomMargin;

    doc.setFontSize(9);
    doc.setTextColor(80);

    const lines = [
      'THE KOREA TIMES DAILY',
      'ADVERTISING DEPT',
      '500 Sheppard Ave, E, Unit 305A',
      'Toronto, ON, M2N 6H7',
      'Tel: 416-787-1111 Ext. 312'
    ];

    lines.forEach((line) => {
      doc.text(line, pageWidth - rightMargin, y, {
        align: 'right'
      });
      y += 4.5;
    });
  };

  // 합계
  const lastY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(12);
  doc.text(`Total: ${precisionRound(sum.total).toLocaleString()}`, 14, lastY);
  doc.text(`Paid Total: ${precisionRound(sum.paidTotal).toLocaleString()}`, 14, lastY + 8);
  doc.text(`Balance: ${precisionRound(sum.balance).toLocaleString()}`, 14, lastY + 16);

  addCompanyFooter(doc);

  const fileName = `Statement_${safeFileName(companyName)}_${companyId}_${todayString()}.pdf`;
  doc.save(fileName);
};

export default StatementPDF;
